import { render, staticRenderFns } from "./SelectFormDialog.vue?vue&type=template&id=1724fae3&"
import script from "./SelectFormDialog.vue?vue&type=script&lang=js&"
export * from "./SelectFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports